export default {
  movieColorArray: [
    "#39A0EA",
    "#30C0CA",
    "#56C172",
    "#8996D1",
    "#6E79D5",
    "#6998AF",
    "#B6C618",
    "#F8CF5B",
    "#E9934F",
    "#E4776A",
    "#9CCFF3",
    "#97DFE4",
    "#AAE0B8",
    "#C3CAE7",
    "#9AA1DF",
    "#B2CBD7",
    "#D8E279",
    "#FBE7AD",
    "#F4C9A7",
    "#F1BBB4"
  ],
  tagColorMapping: {
    "overall": "#39A0EA",
    "male": "#39A0EA",
    "female": "#E4776A",
    "below25": "#F4C9A7",
    "above25": "#E9934F",
    "male_below25": "#9CCFF3",
    "male_above25": "#39A0EA",
    "female_below25": "#F1BBB4",
    "female_above25": "#E4776A",
    "tier1": "#CED7DC",
    "tier2": "#607D8C",
    "tier3": "#30393E",
    "below30": "#F4C9A7",
    "above30": "#E9934F",
    "male_below30": "#9CCFF3",
    "male_above30": "#39A0EA",
    "female_below30": "#F1BBB4",
    "female_above30": "#E4776A",
    "layer1": "#BBEAFF",
    "layer2": "#4FC3F7",
    "layer3": "#0291EA",
    "layer4": "#01579B",
    "student": "#E9934F",
    "non_student": "#F4C9A7",
    "parent": "#E9934F",
    "non_parent": "#F4C9A7"
  }
}